// toggle the associated checkbox on space key press
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".facets-checkbox__marker").forEach((marker) => {
    marker.addEventListener("keydown", function (event) {
      if (event.key === " ") {
        event.preventDefault();
        const checkbox = this.previousElementSibling;
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event("change"));
      }
    });
  });
});


// focus the facets menu close when tab key is pressed after reset-button
document.addEventListener("DOMContentLoaded", function () {
  const closeButton = document.getElementById("facetsMenuClose");
  const simpleButton = document.querySelector(".button--simple");

  if (closeButton && simpleButton) {
    simpleButton.addEventListener("blur", function (event) {
      if (document.activeElement !== closeButton) {
        closeButton.focus();
      }
    });
  }
});


// facets menu can only be accessed via keyboard when open
document.addEventListener("DOMContentLoaded", () => {
  const offcanvasMenu = document.querySelector(".facets-menu");
  const toggleButton = document.querySelector(".open_filters");
const focusableElements = offcanvasMenu.querySelectorAll(
  "a, button, input, textarea, select, [tabindex]"
);

const setFocusable = (enable) => {
  focusableElements.forEach((el) => {
    if (el.classList.contains('facets__price-range__input')) {
      el.tabIndex = enable ? 2 : -1;
    } else if (el.type === 'range') {
      el.tabIndex = enable ? 1 : -1;
    } else {
      el.tabIndex = enable ? 0 : -1;
    }
  });
};

  const openMenu = () => {
    offcanvasMenu.classList.add("is-open");
    offcanvasMenu.setAttribute("aria-hidden", "false");
    toggleButton.setAttribute("aria-expanded", "true");
    setFocusable(true);
    // Optional: Fokus auf das erste Element setzen
    focusableElements[0]?.focus();
  };

  const closeMenu = () => {
    offcanvasMenu.classList.remove("is-open");
    offcanvasMenu.setAttribute("aria-hidden", "true");
    toggleButton.setAttribute("aria-expanded", "false");
    setFocusable(false);
    // Optional: Fokus zurück zum Toggle-Button setzen
    toggleButton.focus();
  };

  // Initial: Menü deaktivieren
  setFocusable(false);
  offcanvasMenu.setAttribute("aria-hidden", "true");

  // Toggle-Button Event
  toggleButton.addEventListener("click", () => {
    if (offcanvasMenu.classList.contains("is-open")) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // Optional: Schließen mit Escape-Taste
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && offcanvasMenu.classList.contains("is-open")) {
      closeMenu();
    }
  });
});

// make range input field controllable via arrow keys
document.querySelectorAll(".facets__price-range__input").forEach((input) => {
  input.addEventListener("keydown", function (event) {
    const step = 1; // Schrittweite für die Erhöhung/Verringerung
    let value = parseInt(this.value, 10) || 0;

    if (event.key === "ArrowUp") {
      event.preventDefault();
      this.value = value + step;
      this.dispatchEvent(new Event("input"));
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      this.value = value - step;
      this.dispatchEvent(new Event("input"));
    }
  });
});
